function markActiveLink(nav: HTMLElement): void {
  const currentPath = window.location.pathname.replace(/index\.html$/, "") || "/";

  nav.querySelectorAll<HTMLAnchorElement>("a").forEach((link) => {
    if (link.hash) return;
    const linkPath = new URL(link.href).pathname.replace(/index\.html$/, "") || "/";
    if (linkPath === currentPath) {
      link.setAttribute("aria-current", "page");
    }
  });
}

export function initNav(): void {
  const toggle = document.getElementById("navToggle");
  const nav = document.getElementById("primaryNav");
  if (!toggle || !nav) return;

  markActiveLink(nav);

  const close = (): void => {
    toggle.setAttribute("aria-expanded", "false");
    nav.classList.remove("is-open");
  };

  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!isOpen));
    nav.classList.toggle("is-open", !isOpen);
  });

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", close);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
  });
}
